export default __webpack_public_path__ + "static/aboutImg-9046b4f212868ac3aacbd42c367af531.jpg";